export enum IProfileIncompleteCookieEnum {
  valid = "valid",
  incomplete = "incomplete",
}

export type IProfileIncompleteCookieValue = keyof typeof IProfileIncompleteCookieEnum;
